<div [id]="animationId" class="animation" #mainAnimation></div>
